import React from "react";
import { number } from "prop-types";

const AuthorDefaultLogo = ({ width = 250, height = 250 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 250 250">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g fillRule="nonzero">
        <g>
          <rect fill="#D2D1D1" x="0" y="0" width="250" height="250"></rect>
          <path
            d="M73.875,119.458333 L94.0416667,119.458333 C138.454565,119.458333 174.458333,155.462101 174.458333,199.875 L174.458333,201.541667 C174.458333,245.954565 138.454565,281.958333 94.0416667,281.958333 L73.875,281.958333 L73.875,119.458333 Z"
            fill="#A6A6A6"
            transform="translate(124.166667, 200.708333) rotate(-90.000000) translate(-124.166667, -200.708333) "
          ></path>
        </g>
      </g>
      <path
        d="M124.583333,164.166667 C148.958333,164.166667 173.333333,142.340548 173.333333,115.416667 C173.333333,88.4927851 151.507215,66.6666667 124.583333,66.6666667 C97.6594518,66.6666667 75.8333333,88.4927851 75.8333333,115.416667 C75.8333333,142.340548 100.208333,164.166667 124.583333,164.166667 Z"
        id="Oval-2"
        stroke="#D2D1D1"
        strokeWidth="5"
        fill="#A6A6A6"
        fillRule="nonzero"
      ></path>
    </g>
  </svg>
);

AuthorDefaultLogo.propTypes = {
  width: number,
  height: number,
};

export default AuthorDefaultLogo;
